export default{
    typeOfGravidity : 'type Of Gravidity',
    ectopicPregnancy : 'EctopicPregnancy(EP)',
    intrauterinePregnancy : 'Intrauterine Pregnancy(IP)',
    abortionInformation : 'Abortion Information',
    parityInformation : 'Parity Information',
    molarInformation : 'Molar Information',
    ipType : 'Intrauterine Pregnancy(IP) Type',
    LocationOfEctopicPregnancy : 'Location of EctopicPregnancy',
    GA : 'G.A(week) ',
    ttc : 'TTC',
    typeOfSurgical : 'type of surgical',
    methodOfPregnancy : 'method of pregnancy',
    typeOfParity : 'type of parity نوع زایمان',
    lch : 'LCH',
    dch : 'DCH',
    parityDate : 'parity date',
    abortionDate : 'Abortion Date',
    parity : 'Parity',
    abortion : 'Abortion',
    typeOfAbortion :'Type Of Abortion',
    causeOfAbortion :'Cause Of Abortion',
    methodOfAbortion :'Method Of Abortion',
}